// extracted by mini-css-extract-plugin
export default {"check":"check-Ovi3"};